import {
  Text,
  Box,
  SimpleGrid,
  GridItem,
  FormControl,
  Input,
  Select,
  Stack,
  Wrap,
  WrapItem,
  Tag,
  Image,
  Button,
  Modal,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  useToast,
  FormErrorMessage,
  Checkbox,
  FormLabel,
  Icon,
  ModalOverlay,
  Popover,
  Menu,
  PopoverTrigger,
  MenuButton,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  Center,
  Spinner,
  Flex,
} from '@chakra-ui/react';
import { Field, FormikProvider, getIn, useFormik } from 'formik';
import { useStore } from '../../../utils/useStore';
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { DAY_LABELS_ES, daysArray } from '../../../utils/constants';
import { useBikletaPointsService } from '../../../services/bikletaPoints/bikletaPointsService';
import { useNavigate } from 'react-router-dom';
import InputData from './inputdata';
import MapComponent from '../../../extra/MapComponent';
import { Marker } from '@react-google-maps/api';
import CustomField from '../../../components/Admin/FormSection/customField';
import { ChevronDownIcon, CloseIcon } from '@chakra-ui/icons';
import { UploadIcon } from '../../../components/Icons/Icons';
import { FilePond } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import {
  BikeIcon,
  FlagLocationIcon,
  RunnerIcon,
  ToolIcon,
  CarretArrowDownIcon,
} from '../../../components/Icons/Icons';
import { IoIosArrowDown } from 'react-icons/io';
import { HiArrowLeft } from 'react-icons/hi';
import { useCommerceProfileViewController } from './commerce-profile.controller';
import { useFormSectionController } from '../../../components/Admin/FormSection/formStepper.controller';
import { TbBeer, TbCoffee } from 'react-icons/tb';
import { MdRestaurant } from 'react-icons/md';

const ProfileEdit: React.FC = ({}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { activePoint } = useStore();
  const navigate = useNavigate();
  const controller = useCommerceProfileViewController();
  const toast = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async values => {
    try {
      await controller.submitEditedData(activePoint._id, values);
      toast({
        title: 'Cambios realizados',
        position: 'top-right',
        status: 'success',
        duration: 2500,
      });
      navigate('/admin/commerce-profile');
    } catch (error) {
      throw new Error(error);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const EditFormSchema = Yup.object().shape({
    name: Yup.string()
      .min(2, 'Demasiado corto!')
      .max(50, 'Demasiado largo!')
      .required('Ingrese el nombre del Negocio'),
    email: Yup.string()
      .email('Correo invalido!')
      .required('Debe colocar un correo'),
    phone: Yup.string(),
    phoneRegion: Yup.string(),
    web: Yup.string(),
    instagram: Yup.string(),
    facebook: Yup.string(),
    tiktok: Yup.string(),
    googleBusiness: Yup.string(),
    images: Yup.array(),
    type: Yup.string()
      .min(2, 'Demasiado corto!')
      .max(50, 'Demasiado largo!')
      .required('Seleccione el tipo de Negocio'),
    point: Yup.object().shape({
      lat: Yup.number().required(
        'Complete los datos de Dirección - Punto en el mapa'
      ),
      lng: Yup.number().required(
        'Complete los datos de Dirección - Punto en el mapa'
      ),
    }),
    address: Yup.string().required('Complete los datos de Dirección'),
  });

  const formik = useFormik({
    initialValues: activePoint
      ? {
          name: activePoint.name,
          type: activePoint.types,
          email: activePoint.email,
          phone: activePoint?.phone || '',
          address: activePoint.address,
          point: {
            lat: activePoint.location.coordinates[1],
            lng: activePoint.location.coordinates[0],
          },
          web: activePoint?.socials?.web || '',
          instagram: activePoint?.socials?.instagram || '',
          facebook: activePoint?.socials?.facebook || '',
          tiktok: activePoint?.socials?.tiktok || '',
          googleBusiness: activePoint?.socials?.googleBusiness || '',
          workTime: Array.isArray(activePoint.workTime)
            ? activePoint.workTime
            : [],
          images: activePoint.images || [],
        }
      : {
          name: '',
          type: '',
          email: '',
          phone: '',
          address: '',
          point: { lat: 0, lng: 0 },
          web: '',
          instagram: '',
          facebook: '',
          tiktok: '',
          googleBusiness: '',
          workTime: [],
          images: [],
        },
    validationSchema: EditFormSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });

  useEffect(() => {
    // Only validate days that have at least one time field filled
    // This allows users to check a day and fill times gradually without disabling the save button
    const hasInvalidWorkTime = formik.values?.workTime?.some((item: any) => {
      const hasOpenTime = item.openTime && item.openTime !== '';
      const hasCloseTime = item.closeTime && item.closeTime !== '';

      // Only invalid if one time is filled but the other is not
      // Both empty is OK (user just checked the box)
      // Both filled is OK
      return (hasOpenTime && !hasCloseTime) || (!hasOpenTime && hasCloseTime);
    });

    if (hasInvalidWorkTime) {
      setIsSubmitting(false);
    } else {
      if (formik.dirty || formik.isSubmitting) {
        setIsSubmitting(true);
      } else {
        setIsSubmitting(false);
      }
    }
  }, [formik.dirty, formik.isSubmitting, formik.values?.workTime]);

  // Show loading while activePoint is being fetched
  if (!activePoint) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  return (
    <Stack>
      <Box
        display="flex"
        flexDirection={'row'}
        alignContent={'center'}
        mb={5}
        ml={2}>
        <Button w={'24px'} h={'24px'} background={'none'} onClick={onOpen}>
          <Icon as={HiArrowLeft} boxSize={6} />
        </Button>
        <Text mr={5}>Editar Perfil</Text>
      </Box>
      <SimpleGrid columns={2} spacing={10}>
        <SimpleGrid columns={1}>
          <FormProfileEdit formik={formik} />
          <ScheduleEditingSection formik={formik} />
        </SimpleGrid>
        <ImagesEditSection formik={formik} />
      </SimpleGrid>
      <SimpleGrid
        pt={20}
        width={'min-content'}
        display={'flex'}
        flexDirection={'row'}
        alignSelf={'flex-end'}>
        <Button onClick={onOpen}>Cancelar</Button>
        <Button
          ml={5}
          mr={10}
          textColor={isSubmitting ? 'black' : 'white'}
          isDisabled={!isSubmitting}
          backgroundColor={
            isSubmitting ? '#FFC700' : 'rgba(255, 240, 255, 0.2)'
          }
          onClick={() => handleSubmit(formik.values)}>
          Guardar Cambios
        </Button>
      </SimpleGrid>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent style={{ backgroundColor: '#2B2930', borderRadius: 28 }}>
          <ModalHeader fontWeight="md">Descartar Cambios</ModalHeader>
          <ModalBody paddingTop={0} paddingBottom={0}>
            <Text fontSize={14} mt={2}>
              ¿Confirmas que quieres descartar los cambios? Las modificaciones
              que hayas realizado no se aplicarán
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={onClose}
              mr={3}
              rounded={'full'}
              fontWeight="md"
              fontSize={14}>
              Cancelar
            </Button>
            <Button
              colorScheme="brand"
              onClick={() => handleBack()}
              mr={3}
              rounded={'full'}
              fontWeight="md"
              fontSize={14}>
              Aceptar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Stack>
  );
};
export default ProfileEdit;

const FormProfileEdit = ({ formik }) => {
  const setStyle = dataInput => {
    const styling = {
      container: {
        maxWidth: dataInput?.name === 'phoneRegion' ? '25%' : null,
        minWidth: dataInput?.name === 'phone' ? '65%' : null,
        display: 'flex',
        justifyContent: 'space-between',
      },
      label: {
        position: 'absolute',
        top: '-0.6em',
        left: '1.2em',
        paddingInline: 5,
        color: 'gray.500',
        backgroundColor: '#313149',
        fontSize: 'sm',
        transition: '0.2s ease all',
        fontWeight: 'md',
        zIndex: 2,
      },
    };
    return styling;
  };

  return (
    <FormikProvider value={formik}>
      <Box>
        <SimpleGrid display={'grid'}>
          <GridItem mt={[5, null, 0]} colSpan={2}>
            <Stack px={4} p={[null, 6]} spacing={6}>
              <SimpleGrid spacing={4}>
                {InputData.businessnameInput.map((item, index) => (
                  <CustomField
                    key={index}
                    dataInput={item}
                    styling={setStyle(null)}
                    filetype={Input}
                  />
                ))}
                <CategoriesEdit formik={formik} />
                <Box mt={10}>
                  <Text>Informacion de contacto</Text>
                  {InputData.dataInput.map((dataInput, index) =>
                    index !== 1 ? (
                      <CustomField
                        key={index}
                        dataInput={dataInput}
                        styling={setStyle(null)}
                        filetype={Input}
                      />
                    ) : (
                      <Box
                        key={index}
                        display="flex"
                        justifyContent={'space-between'}
                        flexDirection={'row'}
                        height={'-moz-min-content'}>
                        {dataInput.phone.map((dataInput, index) => (
                          <CustomField
                            key={index}
                            dataInput={{
                              ...dataInput,
                              formik: formik.values?.phoneRegion,
                            }}
                            styling={setStyle(dataInput)}
                            filetype={
                              dataInput?.name === 'phoneRegion' ? Select : Input
                            }
                          />
                        ))}
                      </Box>
                    )
                  )}
                  <MapSeccion formik={formik} />
                </Box>
              </SimpleGrid>
            </Stack>
          </GridItem>
        </SimpleGrid>
      </Box>
    </FormikProvider>
  );
};

const CategoriesEdit = ({ formik }) => {
  const { activePoint } = useStore();
  const bikletaPointsService = useBikletaPointsService();
  const [selectedTags, setSelectedTags] = useState([]);
  const [pointTypes, setPointTypes] = useState<
    { _id: string; value: string; label: string }[]
  >([]);
  const [isLoadingTypes, setIsLoadingTypes] = useState(true);

  useEffect(() => {
    const fetchPointTypes = async () => {
      try {
        setIsLoadingTypes(true);
        const response = await bikletaPointsService.getPointTypes();
        const types = response.docs.map(type => ({
          _id: type._id,
          value: type.value,
          label: type.label,
        }));
        setPointTypes(types);
      } catch (error) {
        console.error('Error fetching point types:', error);
        setPointTypes([]);
      } finally {
        setIsLoadingTypes(false);
      }
    };

    fetchPointTypes();
  }, []);

  const handleTagClick = tag => {
    if (selectedTags?.find(t => t === tag._id)) {
      const updatedTags = selectedTags.filter(value => value !== tag._id);
      setSelectedTags(updatedTags);
      formik.setFieldValue('type', updatedTags);
    } else {
      const updatedTags = [...selectedTags, tag._id];
      setSelectedTags(updatedTags);
      formik.setFieldValue('type', updatedTags);
    }
  };

  useEffect(() => {
    if (activePoint && activePoint.types && pointTypes.length > 0) {
      setSelectedTags(activePoint.types.map(type => type._id));
      formik.setFieldValue(
        'type',
        activePoint.types.map(type => type._id)
      );
    }
  }, [activePoint, pointTypes]);

  return (
    <Box mt={5}>
      <Text mb={8}>Categorías del negocio</Text>
      {isLoadingTypes ? (
        <Center my={4}>
          <Spinner size="md" />
        </Center>
      ) : (
        <Wrap p={2} spacing={4}>
          {pointTypes.map((tag, index) => {
            if (!tag) return null;
            const isSelected = selectedTags.includes(tag._id);
            return (
              <WrapItem key={index}>
                <Tag
                  size="lg"
                  variant="solid"
                  background={isSelected ? '#D8D7E2' : 'transparent'}
                  cursor="pointer"
                  onClick={() => handleTagClick(tag)}
                  textColor={isSelected ? 'black' : 'white'}
                  border={'1px solid #D8D7E2'}>
                  {tag.label}
                </Tag>
              </WrapItem>
            );
          })}
        </Wrap>
      )}
    </Box>
  );
};

const MapSeccion = ({ formik }) => {
  const initRef = React.useRef();
  let debounceTimer;
  const controller = useFormSectionController();
  const debounce = (callback, time) => {
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(callback, time);
  };

  const [coords, setCoords] = useState<{ lat: number; lng: number } | null>(
    null
  );
  const [geoError, setGeoError] = useState<string | null>(null);
  const [requestingLocation, setRequestingLocation] = useState(false);

  type LatLng = { lat: number; lng: number };
  const getUserLatLng = (): Promise<LatLng> => {
    return new Promise((resolve, reject) => {
      if (!('geolocation' in navigator)) {
        reject(new Error('Geolocalización no disponible'));
        return;
      }
      navigator.geolocation.getCurrentPosition(
        pos =>
          resolve({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          }),
        reject,
        { enableHighAccuracy: true, timeout: 10_000, maximumAge: 30_000 }
      );
    });
  };

  const requestLocation = async () => {
    if (coords || requestingLocation) return;
    setRequestingLocation(true);
    try {
      const c = await getUserLatLng();
      setCoords(c);
      setGeoError(null);
    } catch (e: any) {
      setGeoError(e?.message ?? 'No se pudo obtener tu ubicación');
    } finally {
      setRequestingLocation(false);
    }
  };
  return (
    <SimpleGrid mt={10} columns={6} spacing={4} as={GridItem} colSpan={6}>
      <FormControl
        mb={5}
        as={GridItem}
        colSpan={{ sm: 6, md: 6 }}
        style={{ zIndex: 1000, position: 'relative' }}
        isInvalid={getIn(formik.errors, 'address')}
        zIndex={1}
        isRequired>
        <Popover closeOnBlur={false} placement="top" initialFocusRef={initRef}>
          {({ isOpen, onClose }) => (
            <Box w={'100%'}>
              <Menu>
                <PopoverTrigger>
                  <MenuButton
                    as={Button}
                    rounded="lg"
                    minW="100%"
                    maxW="100%"
                    size="lg"
                    backgroundColor={'transparent'}
                    border={'1px solid'}
                    borderColor="#79747E"
                    _hover={{ backgroundColor: 'transparent' }}
                    _focusWithin={{ borderColor: 'brand.50' }}
                    textAlign={'left'}
                    fontWeight="normal"
                    rightIcon={<ChevronDownIcon />}>
                    <Text isTruncated>
                      {formik.values?.address === ''
                        ? 'Elija su ubicación...'
                        : formik.values?.address}
                    </Text>
                  </MenuButton>
                </PopoverTrigger>
              </Menu>
              <PopoverContent w={'47vw'}>
                <PopoverHeader w="100%">
                  <Input
                    ref={initRef}
                    type={'text'}
                    placeholder="Buscar dirección..."
                    size={'sm'}
                    rounded={'md'}
                    p={2}
                    onChange={event =>
                      debounce(() => {
                        event.target.value !== '' &&
                          controller.setSearchQuery(event.target.value, coords);
                      }, 1000)
                    }
                  />
                </PopoverHeader>
                <PopoverBody
                  maxH={'40vh'}
                  minW={'100%'}
                  overflowY="auto"
                  p={0}
                  bgColor="transparent"
                  sx={{
                    '&::-webkit-scrollbar': {
                      width: '7px',
                      borderRadius: '10px',
                      backgroundColor: `rgba(0, 0, 0, 0.1)`,
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: `rgba(0, 0, 0, 0.4)`,
                      borderRadius: '10px',
                    },
                  }}>
                  {controller.loadingData ? (
                    <Center my={4}>
                      <Spinner size="md" />
                    </Center>
                  ) : !controller.placesSearchResults ? null : controller
                      .placesSearchResults?.length > 0 ? (
                    controller.placesSearchResults.map((place, key) => (
                      <Button
                        w={'100%'}
                        maxW={'100%'}
                        variant="ghost"
                        rounded={'none'}
                        justifyContent={'flex-start'}
                        onClick={() => {
                          formik.setFieldValue('address', place.displayName);

                          formik.setFieldValue('point', {
                            lat: parseFloat(place.lat),
                            lng: parseFloat(place.lng),
                          });
                          onClose();
                        }}
                        key={'TypeItem-' + key}
                        isTruncated>
                        <Text isTruncated fontWeight={'normal'}>
                          {place.displayName}
                        </Text>
                      </Button>
                    ))
                  ) : (
                    <Text my={4}>Sin resultados</Text>
                  )}
                </PopoverBody>
                <Box px={3} py={2} bgColor="blackAlpha.300">
                  {coords ? (
                    <Text fontSize="sm" color="whiteAlpha.900">
                      Usando tu ubicación para mejores resultados.
                    </Text>
                  ) : geoError ? (
                    <Flex direction="column" gap={2} align="flex-start">
                      <Text fontSize="sm" color="whiteAlpha.900">
                        No pudimos acceder a tu ubicación.
                      </Text>
                      <Text fontSize="xs" color="whiteAlpha.800">
                        {geoError}
                      </Text>
                      <Button
                        size="xs"
                        colorScheme="yellow"
                        isLoading={requestingLocation}
                        onClick={requestLocation}>
                        Reintentar
                      </Button>
                    </Flex>
                  ) : (
                    <Flex align="center" justify="space-between" gap={3}>
                      <Text fontSize="sm" color="whiteAlpha.900">
                        Activa tu ubicación para priorizar direcciones cercanas.
                      </Text>
                      <Button
                        size="xs"
                        colorScheme="yellow"
                        isLoading={requestingLocation}
                        onClick={requestLocation}>
                        Activar
                      </Button>
                    </Flex>
                  )}
                </Box>
              </PopoverContent>
            </Box>
          )}
        </Popover>
        {getIn(formik.errors, 'type') ? (
          <FormErrorMessage fontSize={'x-small'}>
            {getIn(formik.errors, 'type')}
          </FormErrorMessage>
        ) : null}
        <FormLabel
          style={{
            position: 'absolute',
            top: '-0.7em',
            left: '1.2em',
            paddingInline: 5,
            color: 'gray.500',
            backgroundColor: '#313149',
            fontSize: 'sm',
            transition: '0.2s ease all',
            fontWeight: 'md',
            zIndex: 2,
          }}
          pointerEvents="none"
          htmlFor="name"
          _dark={{
            color: 'gray.50',
          }}>
          Ubicación
        </FormLabel>
      </FormControl>
      <FormControl
        as={GridItem}
        colSpan={{ sm: 6, md: 6 }}
        style={{ borderRadius: 50 }}>
        <Box
          borderRadius={20}
          overflow="hidden"
          borderWidth={1.5}
          borderColor="gray.500">
          <MapComponent
            height={'25vh'}
            center={
              formik.values?.point.lat && formik.values?.point.lng
                ? {
                    lat: formik.values?.point.lat,
                    lng: formik.values?.point.lng,
                  }
                : null
            }
            zoom={
              formik.values?.point.lat && formik.values?.point.lng ? 15 : null
            }
            options={{
              zoomControl: false,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: false,
              styles: [
                {
                  featureType: 'poi',
                  stylers: [{ visibility: 'off' }],
                },
                {
                  featureType: 'poi.business',
                  stylers: [{ visibility: 'off' }],
                },
                {
                  featureType: 'poi',
                  elementType: 'labels',
                  stylers: [{ visibility: 'off' }],
                },
                {
                  featureType: 'poi.business',
                  elementType: 'labels',
                  stylers: [{ visibility: 'off' }],
                },
              ],
            }}>
            {formik.values?.point.lat && formik.values?.point.lng && (
              <Marker
                key={'New-BP'}
                position={{
                  lat: formik.values?.point.lat,
                  lng: formik.values?.point.lng,
                }}
              />
            )}
          </MapComponent>
        </Box>
      </FormControl>
    </SimpleGrid>
  );
};

const ImagesEditSection = ({ formik }) => {
  const { activePoint } = useStore();
  const [images, setImages] = useState(formik.values?.images || []);

  const handleDeleteImages = image => {
    const updatedImages = images.filter(value => value !== image);
    setImages(updatedImages);
    formik.setFieldValue('images', updatedImages);
  };

  useEffect(() => {
    setImages(formik.values?.images || []);
  }, [activePoint]);

  return (
    <Stack display={'flex'} alignItems={'center'}>
      <Stack>
        <Text mb={2}>Fotos de tu negocio</Text>
        <Text mb={2} fontSize={'sm'}>
          Muestra fotos atractivas de lo que tu negocio ofrece <br />
          Formato adimitido: JPG o PNG. Máximo: 5 fotos
        </Text>
        <Stack>
          {images.length < 5 && (
            <UploadPhotosModal
              key={'UploadPhotosModal'}
              formik={formik}
              imageUpdate={setImages}
            />
          )}
          {images &&
            images.map((image, index) => (
              <Box
                key={index}
                position="relative"
                borderRadius="md"
                overflow="hidden"
                display={'flex'}
                paddingBlock={2.5}
                justifyContent={'right'}>
                <Button
                  zIndex={11}
                  position={'absolute'}
                  mt={2}
                  mr={2}
                  backgroundColor={'#D8D7E2'}
                  borderRadius={50}
                  height={'2.8em'}
                  _hover={{ boxShadow: 'none' }}
                  onClick={() => handleDeleteImages(image)}>
                  <CloseIcon color={'black'} />
                </Button>
                <Image
                  position={'relative'}
                  src={image}
                  alt={'bussines-image'}
                  borderRadius={20}
                  maxW={'390px'}
                  maxH={'280px'}
                  zIndex={10}
                />
              </Box>
            ))}
        </Stack>
      </Stack>
    </Stack>
  );
};

const UploadPhotosModal = ({ formik, imageUpdate }) => {
  const toast = useToast();
  const bikletaPointsService = useBikletaPointsService();
  const [imageArray, setImageArray] = useState<any[]>([]);
  const [isUploading, setIsUploading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleUploadPhtos = async imageArray => {
    try {
      setIsUploading(true);

      // Upload images to get URLs
      const uploadedUrls: string[] = [];
      for (let i = 0; i < imageArray.length; i++) {
        const file = imageArray[i];
        toast({
          title: 'Subiendo imágenes...',
          description: `${i + 1} de ${imageArray.length} imagen(es)`,
          status: 'info',
          duration: 1000,
        });

        const uploadedImage = await bikletaPointsService.postImage(file.file);
        uploadedUrls.push(uploadedImage.url);
      }

      // Add new URLs to existing images
      const currentImages = formik.values.images || [];
      formik.setFieldValue('images', [...currentImages, ...uploadedUrls]);
      imageUpdate(prevImages => [...prevImages, ...uploadedUrls]);

      toast({
        title: 'Imágenes subidas correctamente',
        status: 'success',
        duration: 2000,
      });

      setImageArray([]);
      onClose();
    } catch (error) {
      console.error('Error uploading images:', error);
      toast({
        title: 'Error al subir imágenes',
        description: 'Por favor intenta nuevamente',
        status: 'error',
        duration: 3000,
      });
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Stack>
      <Button backgroundColor={'#363449'} onClick={onOpen}>
        <UploadIcon color={'white'} />
        Subir fotos
      </Button>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalContent>
          <ModalHeader>Subir nueva imagen</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormikProvider value={formik}>
              <FormControl
                as={GridItem}
                colSpan={6}
                isInvalid={getIn(formik.errors, 'images')}
                isRequired>
                <Field
                  as={FilePond}
                  key="images"
                  instantUpload={false}
                  upload="false"
                  maxFileSize={'3MB'}
                  labelMaxFileSizeExceeded="Archivo demasiado grande"
                  labelMaxFileSize="Tamaño máximo: 3MB"
                  allowMultiple
                  maxFiles={5}
                  maxParallelUploads={5}
                  imagePreviewMaxHeight={120}
                  acceptedFileTypes={['image/*']}
                  onupdatefiles={images => {
                    setImageArray(images);
                  }}
                  labelIdle='Arrastre las imagenes o <span class="filepond--label-action">elijalas desde archivo</span>'
                  labelFileLoading="Cargando"
                  labelFileProcessing="Procesando"
                  labelFileProcessingComplete="Procesado"
                  labelFileProcessingError="Error"
                  labelTapToCancel="Cancelar"
                  labelTapToRetry="Reintentar"
                  labelTapToUndo="Deshacer"
                  labelButtonRemoveItem="Eliminar"
                  labelFileLoadError={'Error al cargar el archivo'}
                  onwarning={error => {
                    toast({
                      title: 'Limite de imagenes excedido',
                      description: 'Solo se pueden subir 5 imagenes',
                      status: 'info',
                      duration: 5000,
                      isClosable: true,
                      position: 'top',
                    });
                  }}
                  onerror={error => {
                    formik.setFieldError('images', error.main);
                  }}
                />
                {getIn(formik.errors, 'images') ? (
                  <FormErrorMessage fontSize={'x-small'}>
                    {getIn(formik.errors, 'images')}
                  </FormErrorMessage>
                ) : null}
              </FormControl>
            </FormikProvider>
          </ModalBody>
          <ModalFooter>
            <Button
              mr={3}
              onClick={() => handleUploadPhtos(imageArray)}
              isDisabled={imageArray.length === 0 || isUploading}
              isLoading={isUploading}>
              Agregar
            </Button>
            <Button onClick={onClose} isDisabled={isUploading}>
              Cerrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Stack>
  );
};
const ScheduleEditingSection = ({ formik }) => {
  const DAYS_ORDER = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ];

  return (
    <Box mt={20} paddingInline={5}>
      <Text mb={5}>Horarios comerciales</Text>
      <FormikProvider value={formik}>
        <FormControl as={GridItem} colSpan={6}>
          <Stack spacing={3}>
            {DAYS_ORDER.map((dayKey, index) => (
              <OpenTimeForm
                key={`day-${dayKey}`}
                dayKey={dayKey}
                formik={formik}
              />
            ))}
          </Stack>
        </FormControl>
      </FormikProvider>
    </Box>
  );
};

type OpenTimeFormProps = {
  dayKey: string;
  formik: any;
};

const OpenTimeForm = ({ dayKey, formik }: OpenTimeFormProps) => {
  const { values, setFieldValue } = formik;

  // Find if this day exists in workTime array
  const dayIndex = values.workTime?.findIndex((wt: any) => wt.day === dayKey);
  const dayData = dayIndex >= 0 ? values.workTime[dayIndex] : null;

  const hasDay = dayIndex >= 0;
  const hasCompleteTimes = Boolean(dayData?.openTime && dayData?.closeTime);
  // esto es lo que pedís: si viene el día pero open/close null => false
  const opens = hasCompleteTimes;
  const openTime = dayData?.openTime ?? '';
  const closeTime = dayData?.closeTime ?? '';
  const workDay = DAY_LABELS_ES[dayKey];

  const handleTimeChange = (field: string, value: any) => {
    if (!opens && field === 'opens' && value) {
      // Add new day to workTime array
      const newWorkTime = [
        ...(values.workTime || []),
        {
          day: dayKey,
          openTime: '',
          closeTime: '',
        },
      ];
      setFieldValue('workTime', newWorkTime);
    } else if (opens && field === 'opens' && !value) {
      // Remove day from workTime array
      const newWorkTime = values.workTime.filter(
        (wt: any) => wt.day !== dayKey
      );
      setFieldValue('workTime', newWorkTime);
    } else if (dayIndex >= 0) {
      setFieldValue(`workTime[${dayIndex}].${field}`, value);
    }
  };

  const handleToggleDay = (checked: boolean) => {
    if (checked) {
      if (dayIndex >= 0) {
        // estaba cerrado (null/null) o incompleto => lo habilito para editar
        setFieldValue(
          `workTime[${dayIndex}].openTime`,
          dayData?.openTime ?? ''
        );
        setFieldValue(
          `workTime[${dayIndex}].closeTime`,
          dayData?.closeTime ?? ''
        );
        return;
      }
      // no existía: lo agrego habilitado
      setFieldValue('workTime', [
        ...(values.workTime || []),
        { day: dayKey, openTime: '', closeTime: '' },
      ]);
      return;
    }
    // unchecked => marcar como cerrado
    if (dayIndex < 0) return;
    setFieldValue(`workTime[${dayIndex}].openTime`, null);
    setFieldValue(`workTime[${dayIndex}].closeTime`, null);
  };
  const isClosed = dayData?.openTime === null && dayData?.closeTime === null;
  const isEnabled = Boolean(dayData) && !isClosed; // habilitado si existe y NO está null/null

  return (
    <Stack mt={3}>
      <Box display={'flex'} alignItems={'center'} flexWrap="wrap">
        <Checkbox
          mr={5}
          isChecked={isEnabled}
          onChange={e => handleToggleDay(e.target.checked)}
          colorScheme={'brand.50'}
          sx={{
            '.chakra-checkbox__control[data-checked]': {
              bg: 'brand.50',
              borderColor: 'brand.50',
            },
            '.chakra-checkbox__control[hover]': {
              borderColor: 'brand.50',
            },
          }}
        />
        <Text textColor={isEnabled ? 'white' : '#777672'} minW="100px" mr={4}>
          {workDay}
        </Text>

        {dayIndex >= 0 && (
          <>
            <Box mr={4}>
              <FormControl
                position="relative"
                display={'flex'}
                border={'1px solid var(--M3-sys-light-outline, #79747E);'}
                borderRadius={'4px'}
                minW="120px"
                isDisabled={!isEnabled}>
                <FormLabel
                  position="relative"
                  display={'flex'}
                  flexDir={'row'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  mr={0}
                  mb={0}
                  width="100%">
                  <Input
                    isDisabled={!isEnabled}
                    type="time"
                    value={openTime || ''}
                    onChange={e => handleTimeChange('openTime', e.target.value)}
                    mt={3}
                    shadow="sm"
                    size="xs"
                    w="full"
                    rounded="md"
                    variant="outline"
                    borderColor="#79747E"
                    zIndex={1}
                    p={0}
                    textAlign="center"
                    width={'90px'}
                    border={'none'}
                    placeholder={'00:00'}
                    sx={{
                      '&::-webkit-calendar-picker-indicator': {
                        display: 'none',
                      },
                    }}
                  />
                </FormLabel>
                <FormLabel
                  style={{
                    position: 'absolute',
                    top: '-0.8em',
                    left: '1em',
                    paddingInline: 4,
                    color: 'gray.500',
                    backgroundColor: '#313149',
                    fontSize: '0.8em',
                    transition: '0.2s ease all',
                    fontWeight: 'md',
                    zIndex: 2,
                  }}
                  pointerEvents="none"
                  htmlFor="openTime">
                  <Text textColor={'white'}>{'Desde'}</Text>
                </FormLabel>
              </FormControl>
            </Box>

            <Box mr={4}>
              <FormControl
                position="relative"
                display={'flex'}
                border={'1px solid var(--M3-sys-light-outline, #79747E);'}
                borderRadius={'4px'}
                minW="120px"
                isDisabled={!isEnabled}>
                <FormLabel
                  position="relative"
                  display={'flex'}
                  flexDir={'row'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  mr={0}
                  mb={0}
                  width="100%">
                  <Input
                    isDisabled={!isEnabled}
                    type="time"
                    value={closeTime || ''}
                    onChange={e =>
                      handleTimeChange('closeTime', e.target.value)
                    }
                    mt={3}
                    shadow="sm"
                    size="xs"
                    w="full"
                    rounded="md"
                    variant="outline"
                    borderColor="#79747E"
                    zIndex={1}
                    p={0}
                    textAlign="center"
                    width={'90px'}
                    border={'none'}
                    placeholder={'00:00'}
                    sx={{
                      '&::-webkit-calendar-picker-indicator': {
                        display: 'none',
                      },
                    }}
                  />
                </FormLabel>
                <FormLabel
                  style={{
                    position: 'absolute',
                    top: '-0.8em',
                    left: '1em',
                    paddingInline: 4,
                    color: 'gray.500',
                    backgroundColor: '#313149',
                    fontSize: '0.8em',
                    transition: '0.2s ease all',
                    fontWeight: 'md',
                    zIndex: 2,
                  }}
                  pointerEvents="none"
                  htmlFor="closeTime">
                  <Text textColor={'white'}>{'Hasta'}</Text>
                </FormLabel>
              </FormControl>
            </Box>
          </>
        )}
      </Box>
    </Stack>
  );
};
